import { getAttributeKeys } from '../index';
import { Attributes } from '../../attributes';

export const getBuyerTooltip = (i18n, name, subCategoryId) => {
    const attributeKeys = getAttributeKeys(name, subCategoryId, [
        Attributes.tooltip, Attributes.buyerDescription
    ]);

    return i18n.t(attributeKeys);
};
